<template>
  <!-- 点検編集 -->
  <div id="AppInspectionEditContents">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">点検情報編集</label>
        </div>
      </div>
    </div>
    <div style="margin-left: 50px; margin-Right: 50px;">
      <!-- 詳細表示 -->
      <div style="detailArea">
        <div>
          <div style="height:10px;"></div>
          <table class="table is-full">
            <table style="width: 100%;">
              <tr>
                <th style="border-bottom: solid 1px; width: 150px;">点検管理番号</th>
                <td style="border-bottom: solid 1px;" colspan="8">{{ data.inspectionCode }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">品目名</th>
                <td style="border-bottom: solid 1px;" colspan="8">{{ data.productName }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">疾患名</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <b-field
                    :type="{'is-danger':errors.has('diseaseName')}"
                    :message="errors.first('diseaseName')"
                  >
                    <b-input
                      v-model="data.diseaseName"
                      name="diseaseName"
                      data-vv-as="疾患名"
                      v-validate="'max:70'"
                      maxlength="70"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">療法（呼吸のみ）</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <b-field
                    :type="{'is-danger':errors.has('therapy')}"
                    :message="errors.first('therapy')"
                  >
                    <b-select v-model="data.therapy" name="therapy" data-vv-as="療法（呼吸のみ）" expanded>
                      <option value="NPPV">NPPV</option>
                      <option value="TPPV">TPPV</option>
                      <option value="HFT">HFT</option>
                      <option value="NPPV/HFT">NPPV/HFT</option>
                      <option value="TPPV/HFT">TPPV/HFT</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">感染症</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <b-field
                    :type="{'is-danger':errors.has('infection')}"
                    :message="errors.first('infection')"
                  >
                    <b-select v-model="data.infection" name="infection" data-vv-as="感染症" expanded>
                      <option value="無し">無し</option>
                      <option value="MRSA">MRSA</option>
                      <option value="HCV">HCV</option>
                      <option value="HBV">HBV</option>
                      <option value="Wa">Wa</option>
                      <option value="その他">その他</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">処方使用時間（呼吸）</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <b-field
                    :type="{'is-danger':errors.has('usageTime')}"
                    :message="errors.first('usageTime')"
                  >
                    <b-select
                      v-model="data.usageTime"
                      name="usageTime"
                      data-vv-as="処方使用時間（呼吸）"
                      data-vv-validate-on="input"
                      v-validate="'selectRange:0:3'"
                      expanded
                    >
                      <option value="0">24時間</option>
                      <option value="1">日中</option>
                      <option value="2">夜間・睡眠時</option>
                      <option value="3">労作時</option>
                      <option value></option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実使用時間</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <b-field>
                    <b-input
                      v-model="elapsedTime"
                      placeholder="Number"
                      type="number"
                      min="0"
                      max="99"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検種別</th>
                <td v-if="data.status == 1" style="border-bottom: solid 1px;" colspan="8">
                  <b-field
                    :type="{'is-danger':errors.has('inspectionKind')}"
                    :message="errors.first('inspectionKind')"
                  >
                    <b-select
                      v-model="data.inspectionKind"
                      name="inspectionKind"
                      data-vv-as="点検種別"
                      expanded
                      @input="updateInspectionKind()"
                    >
                      <option value="0">院内/当社点検有</option>
                      <option value="1">院内/当社点検無し</option>
                      <option value="2">在宅/当社点検</option>
                      <option value="3">在宅/ディーラー点検</option>
                      <option value="4">院内・在宅/RR点検不要</option>
                      <option value="5">社内器</option>
                      <option value="6">フリーメンテ</option>
                    </b-select>
                  </b-field>
                </td>
                <td
                  v-else
                  style="border-bottom: solid 1px;"
                  colspan="8"
                >{{data.inspectionKind | inspectionTypeFillter}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">器械交換</th>
                <td style="border-bottom: solid 1px;" colspan="8">{{ data.machineReplace }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検指示内容</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="8"
                >{{ data.inspectionOrder |inspectionOrderFilter}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">営業所</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="8"
                >{{ data.officeCode | officeFilter(officeMaster) }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">点検担当者</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  {{data.staffName}}
                  <b-button
                    style="float:right"
                    class="button is-primary has-text-centered"
                    icon-left="account-switch"
                    native-type="button"
                    v-on:click="changeAppointmentStaff"
                  >担当者選択</b-button>
                  <b-modal :active.sync="isStaffChangeModalActive" has-modal-card>
                    <staffChange-modal
                      v-bind:office-code="data.officeCode"
                      v-on:staff-change-event="staffChanged"
                    ></staffChange-modal>
                  </b-modal>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="4">点検状況</th>
                <th style="border-bottom: solid 1px;">実施状況</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <span
                    :class="['tag',
                      {'is-success':data.status == 6},
                      {'is-danger':data.status == 1},
                      {'is-warning':data.status == 2},
                      {'is-warning':data.status == 3},
                      {'is-warning':data.status == 4},
                      {'is-dark':data.status == 5}
                      ]"
                  >{{ data.status | inspectionStatusFillter}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実施予定月</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.scheduledMonth }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">実施日時</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.completionDate }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">次回予定月</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.nextScheduledMonth }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="3">患者情報</th>
                <th style="border-bottom: solid 1px;">患者名</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.patientName }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">患者住所</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <template v-if="data.patientZipCode">〒{{data.patientZipCode}}</template>
                  {{ data.patientAddress }}
                  <b-field class="file" style="float:right">
                    <b-button
                      v-if="data.patientAddress"
                      class="button is-primary has-text-centered"
                      icon-left="google-maps"
                      native-type="button"
                      v-on:click="doShowGoogleMap([
                            {
                                'address': data.patientAddress,
                                'name': data.patientName,
                                'patientZipCode': data.patientZipCode,
                            }
                            ])"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">患者連絡先</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.patientPhone }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;" rowspan="4">医療機関情報</th>
                <th style="border-bottom: solid 1px;">医療機関名</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ data.hospitalName }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">医療機関住所</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <template v-if="data.hospitalZipCode">〒{{data.hospitalZipCode}}</template>
                  {{ data.hospitalAddress }}
                  <b-field class="file" style="float:right">
                    <b-button
                      v-if="data.hospitalAddress"
                      class="button is-primary has-text-centered"
                      icon-left="google-maps"
                      native-type="button"
                      v-on:click="doShowGoogleMap([
                            {
                                'address': data.hospitalAddress,
                                'name': data.hospitalName,
                                'patientZipCode': data.hospitalZipCode,
                            }
                            ])"
                    ></b-button>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">診療科</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <b-field
                    :type="{'is-danger': errors.has('department')}"
                    :message="errors.first('department')"
                  >
                    <b-input
                      v-model="data.department"
                      name="department"
                      data-vv-as="診療科"
                      v-validate="'max:35'"
                      maxlength="35"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">担当医</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <b-field
                    :type="{'is-danger': errors.has('doctorName')}"
                    :message="errors.first('doctorName')"
                  >
                    <b-input
                      v-model="data.doctorName"
                      name="doctorName"
                      data-vv-as="担当医"
                      v-validate="'max:35'"
                      maxlength="35"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <!-- 定期消耗品 -->
              <tr v-for="(item, index) in regularShomou" v-bind:key="index">
                <th
                  style="border-bottom: solid 1px;"
                  v-bind:rowspan="regularCount"
                  v-if="index==0"
                >定期消耗品</th>
                <td style="border-bottom: solid 1px;">
                  <span style="margin-left:10px;">{{item.itemCode}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:250px;" colspan="2">
                  <span style="margin-left:10px;">{{item.itemCode|productFilter(productMaster)}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.preDate" style="margin-left:10px;">{{formatDate(item.preDate)}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.itemCode" style="margin-left:10px;">{{item.interval}}</span>
                  <span style="margin-left:10px;">ヶ月</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.itemCode" style="margin-left:10px;">{{item.count}}</span>
                  <span style="margin-left:10px;">EA</span>
                </td>
                <td style="border-bottom: solid 1px;width:200px;" colspan="2">
                  <span
                    style="margin-left:10px;"
                  >{{getDisposableNextDate(item.preDate,item.interval)}}</span>
                </td>
              </tr>
              <!-- 非定期消耗品 -->
              <tr v-for="(item, index) in nonRegularShomou" v-bind:key="index">
                <th
                  style="border-bottom: solid 1px;"
                  v-bind:rowspan="nonRegularCount"
                  v-if="index==0"
                >非定期消耗品</th>
                <td style="border-bottom: solid 1px;">
                  <span style="margin-left:10px;">{{item.itemCode}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:250px;" colspan="2">
                  <span style="margin-left:10px;">{{item.itemCode|productFilter(productMaster)}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.preDate" style="margin-left:10px;">{{formatDate(item.preDate)}}</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.itemCode" style="margin-left:10px;">{{item.interval}}</span>
                  <span style="margin-left:10px;">ヶ月</span>
                </td>
                <td style="border-bottom: solid 1px;width:150px;">
                  <span v-if="item.itemCode" style="margin-left:10px;">{{item.count}}</span>
                  <span style="margin-left:10px;">EA</span>
                </td>
                <td style="border-bottom: solid 1px;width:200px;" colspan="2">
                  <span
                    style="margin-left:10px;"
                  >{{getDisposableNextDate(item.preDate,item.interval)}}</span>
                </td>
              </tr>
              <tr>
                <!-- 点検報告書送付先-->
                <th style="border-bottom: solid 1px;" rowspan="100">
                  点検報告書送付先
                </th>
                <th style="border-bottom: solid 1px;width:140px;">患者</th>
                <td style="border-bottom: solid 1px;width:230px;">
                  <b-field
                    :type="{'is-danger': errors.has('patientForm')}"
                    :message="errors.first('patientForm')"
                  >
                    <b-select
                      v-model="data.reportDestinationPatientForm"
                      name="patientForm"
                      data-vv-as="送付方法"
                      expanded
                    >
                      <option value="1">手持ち</option>
                      <option value="2">送付</option>
                      <option value="3">点検報告書送付不要</option>
                    </b-select>
                  </b-field>
                </td>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <template v-if="data.patientZipCode">〒{{data.patientZipCode}}</template>
                  {{ data.patientAddress }}
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">医療機関</th>
                <td style="border-bottom: solid 1px;">
                  <b-field
                    :type="{'is-danger': errors.has('hospitalForm')}"
                    :message="errors.first('hospitalForm')"
                  >
                    <b-select
                      v-model="data.reportDestinationHospitalForm"
                      name="hospitalForm"
                      data-vv-as="送付方法"
                      expanded
                    >
                      <option value="1">手持ち</option>
                      <option value="2">送付</option>
                      <option value="3">N/A</option>
                      <option value="4">PCP公開</option>
                      <option value="5">ナビエク郵送</option>
                    </b-select>
                  </b-field>
                </td>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <template v-if="data.hospitalZipCode">〒{{data.hospitalZipCode}}</template>
                  {{ data.hospitalAddress }}
                </td>
              </tr>
            </table>
          </table>
          <div class="column is-full">
            <b-field label="メモ" labelPosition="on-border">
              <b-input
                type="textarea"
                name="inspectionMemo"
                data-vv-as="メモ"
                v-validate="'max:512'"
                maxlength="512"
                rows="10"
                v-model="data.freeMemo"
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isShowGoogleMap" has-modal-card>
      <googleMap-form v-bind:marker="addressList"></googleMap-form>
    </b-modal>
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";
import MapTemplate from "./AppMapView";
import * as inspectionConst from "../utils/inspection";

var regularShomou = [];
var regularCount = 0;
var nonRegularShomou = [];
var nonRegularCount = 0;

const ModalForm = {
  props: ["officeCode"],
  components: {
    staffSearch: StaffSearchTemplate
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      var staffInfo = this.$refs.staffList.getStaff();
      this.officeCode = staffInfo.officeCode;
      this.staffCode = staffInfo.staffCode;
      this.staffName = staffInfo.lastName + staffInfo.firstName;
      this.setStaffs(this.officeCode, this.staffCode, this.staffName);
    },
    setStaffs: function(officeCode, staffCode, staffName) {
      // 選択された担当者情報を親画面に返却
      this.$emit("staff-change-event", officeCode, staffCode, staffName);
      this.$parent.close();
    }
  },
  data() {
    var office = this.$props.officeCode;
    return {
      office
    };
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch ref="staffList" v-on:set-staffs-event="setStaffs" v-bind:office-code="office"/>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};
const MapForm = {
  props: ["marker"],
  components: {
    maps: MapTemplate
  },
  template: `
      <maps :markers="marker" />
    `
};
export default {
  props: ["isnew"],
  name: "AppInspectionEditContents",
  methods: {
    save: function() {
      var excuteApi = this.setInspectionDetailPOST;
      var successCallBack = this.setInspectionDetailPOSTSuccess;
      var errorCallBack = this.setInspectionDetailPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInspectionDetailPOST: function(client) {
      //数値型の選択肢の値をintegerに変換
      this.data.inspectionKind = parseInt(this.data.inspectionKind);

      this.data.reportDestinationHospitalForm = parseInt(
        this.data.reportDestinationHospitalForm
      );
      this.data.reportDestinationPatientForm = parseInt(
        this.data.reportDestinationPatientForm
      );
      var destinations = this.data.extraReportDestination.destinations;
      if (destinations.length > 0) {
        for (var i = 0; i < destinations.length; i++) {
          destinations[i].kind = parseInt(destinations[i].kind);
          destinations[i].sendType = parseInt(destinations[i].sendType);
        }
      }
      var obj = JSON.parse(JSON.stringify(this.data));
      return client.apis.apiInspection.setInspectionDetailPOST({
        body: obj
      });
    },
    setInspectionDetailPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
      this.successEndFlg = true;
    },
    setInspectionDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.successEndFlg = false;
    },
    saveInspectionMemo: function() {
      var excuteApi = this.setInspectionOtherMemoPOST;
      var successCallBack = this.setInspectionOtherMemoPOSTSuccess;
      var errorCallBack = this.setInspectionOtherMemoPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setInspectionOtherMemoPOST: function(client) {
      var obj = {
        patientCode: this.data.patientCode,
        productCode: this.data.productCode,
        serial: this.data.serial,
        reservationId: this.data.appointmentCode,
        freeMemo: this.data.freeMemo,
        editType: "0"
      };
      return client.apis.apiInspection.setInspectionOtherMemoPOST({
        body: obj
      });
    },
    setInspectionOtherMemoPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result);
    },
    setInspectionOtherMemoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    staffChanged: function(officeCode, staffCode, staffName) {
      // 選択された担当者情報をモーダル画面から取得・設定

      // 担当者変更処理
      this.data.staffCode = staffCode;
      this.data.staffName = staffName;
    },
    changeAppointmentStaff: function(event) {
      // アポ担当者変更
      this.isStaffChangeModalActive = true;
    },
    addReportDest: function(item) {
      // 報告書送付先追加
      if (item.length < 5) {
        item.push({});
      } else {
        this.showErrorMessage("点検報告書送付先は5件までしか登録できません。");
      }
    },
    removeReportDest: function(item, index) {
      // 報告書送付先削除
      item.splice(index, 1);
    },
    getZipFieldName: function(index) {
      return "zipCode" + index;
    },
    getAddressFieldName: function(index) {
      return "address" + index;
    },
    getFormFieldName: function(index) {
      return "form" + index;
    },
    getDestKindFieldName: function(index) {
      return "kind" + index;
    },
    getSendTypeFieldName: function(index) {
      return "sendType" + index;
    },
    getInspectionDetailPOST: function(client) {
      return client.apis.apiInspection.getInspectionDetailPOST({
        body: {
          code: this.inspectionCode == "-" ? null : this.inspectionCode,
          productCode: this.productCode,
          patientCode: this.patientCode,
          serial: this.serial
        }
      });
    },
    getInspectionDetailPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      // Number⇒文字列(実施時間)
      if (this.data.elapsedTime) {
        this.elapsedTime = String(this.data.elapsedTime);
      }

      for (var i = 0; i < this.data.disposables.length; i++) {
        this.data.disposables[i].preDate = this.parseDate(
          this.data.disposables[i].preDate
        );
      }
      this.regularShomou = this.data.disposables.filter(
        x => x.deliveryKindFlag == 1
      );
      this.regularCount = this.regularShomou.length;
      this.nonRegularShomou = this.data.disposables.filter(
        x => x.deliveryKindFlag == 9 || x.deliveryKindFlag == null
      );
      this.nonRegularCount = this.nonRegularShomou.length;
      this.inspectionKindOld = this.data.inspectionKind;
    },
    getInspectionDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    isSuccessEnd: function() {
      return this.successEndFlg;
    },
    doShowGoogleMap: function(address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },
    getDeliveryName: function(value) {
      var deliveryElement = this.productMaster.find(
        v => v.productCode === value
      );
      if (deliveryElement) {
        return deliveryElement.productName;
      }
      return "";
    },
    getInspectionDetail: function() {
      var excuteApi = this.getInspectionDetailPOST;
      var successCallBack = this.getInspectionDetailPOSTSuccess;
      var errorCallBack = this.getInspectionDetailPOSTError;
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getProduct: function() {
      var excuteApi = this.getProductListPOST;
      var successCallBack = this.getProductListPOSTSuccess;
      var errorCallBack = this.getProductListPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getProductListPOST: function(client) {
      return client.apis.apiMaster.getProductListPOST({
        body: {}
      });
    },
    getProductListPOSTSuccess: function(result) {
      for (var i = 0, len = result.obj.length; i < len; i++) {
        var productCode = result.obj[i].productCode;
        var productName = result.obj[i].productName;
        var productDataKeyCode = {
          key: productCode + " " + productName,
          productCode: productCode,
          productName: productName
        };
        this.productMaster.push(productDataKeyCode);
      }
      this.productMaster.sort(function(a, b) {
        if (a.key > b.key) {
          return 1;
        } else {
          return -1;
        }
      });
    },
    getProductListPOSTError: function(result) {
      console.log(result);
    },
    getDisposableNextDate: function(disposablePreDate, disposableInterval) {
      // 前回供給日⇒次回供給予定日 の自動計算、設定処理
      var preDate = disposablePreDate;
      var year = parseInt(disposableInterval / 12);
      var month = parseInt(disposableInterval % 12);
      var NextDate = null;
      var stringFlg = typeof preDate == "string";

      if (!preDate) return;
      if (stringFlg) {
        preDate = this.parseDate(disposablePreDate);
      }
      //対象月(前回供給日+期間)の月初日
      var targetFirstDay = new Date(
        Number(preDate.getFullYear() + year),
        Number(preDate.getMonth() + month),
        1
      );
      var targetLastDay = this.parseDate(this.getMonthLastDay(targetFirstDay));
      if (targetLastDay.getDate() >= preDate.getDate()) {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日以上
        // そのまま設定
        NextDate = new Date(
          Number(preDate.getFullYear()) + year,
          Number(preDate.getMonth()) + month,
          preDate.getDate()
        );
      } else {
        // 対象月(次回供給日+期間)の月末日が次回供給予定の日より小さい
        // 対象月の月末日を設定
        NextDate = targetLastDay;
      }
      NextDate = this.formatDate(NextDate);
      return NextDate;
    },
    updateInspectionKind: function() {
      if (this.inspectionKindOld == null) {
        const inspectionKind = Number(this.data.inspectionKind);
        switch (inspectionKind) {
          case inspectionConst.INSPECTION_TYPE_MAP.hospitalMyCompany.code:
          case inspectionConst.INSPECTION_TYPE_MAP.homeMyCompany.code:
          case inspectionConst.INSPECTION_TYPE_MAP.homeDealer.code:
            if (this.data.pcpHospitalNum > 0) {
              this.data.reportDestinationHospitalForm = inspectionConst.SEND_TYPE_HOSPITAL_MAP.pcp.code;
            }
            break;
        }
      }
      this.inspectionKindOld = this.data.inspectionKind;

      return;
    },
  },
  data() {
    var data = {};
    var officeMaster = [];
    var productMaster = [];
    var inspectionCode = this.$route.params["inspectionCode"];
    var productCode = this.$route.params["productCode"];
    var patientCode = this.$route.params["patientCode"];
    var serial = this.$route.params["serial"];
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    return {
      data,
      officeMaster,
      productMaster,
      inspectionCode,
      productCode,
      patientCode,
      serial,
      elapsedTime: "",
      isStaffChangeModalActive: false,
      isShowGoogleMap: false,
      addressList: [],
      successEndFlg: false,
      targetItem: {
        target: "",
        index: 7
      },
      regularShomou,
      regularCount,
      nonRegularShomou,
      nonRegularCount
    };
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    productFilter: function(value, productMaster) {
      var deliveryElement = productMaster.find(v => v.productCode === value);
      if (deliveryElement) {
        return (
          deliveryElement.productName + " (" + deliveryElement.productCode + ")"
        );
      }
      return "";
    }
  },
  components: {
    "staffChange-modal": ModalForm,
    "googleMap-form": MapForm,
  },
  mounted: function() {
    // 画面のちらつき防止
    var appVue = this.$root.$children[0];
    appVue.loadingStart();
    this.getProduct().then(result => {
      this.getInspectionDetail();
    });
    appVue.loadingEnd();
  },
  watch: {
    elapsedTime(value) {
      this.data.elapsedTime = value.toString(10);
    },
  },
  created: function() {}
};
</script>
<style lang="scss">
.autocomplete > .dropdown-menu > .dropdown-content {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppInspectionEditContents.vue